

























import { defineComponent, PropType } from "@vue/composition-api";
import { ListField } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseCheckChip from "@/components/BaseCheckChip";

export default defineComponent({
  name: "PublicInfoRadioGroup",
  components: {
    BaseButton,
    BaseCheckChip,
  },
  props: {
    value: { type: String as PropType<string | null>, default: null },
    items: { type: Array as PropType<ListField[]>, required: true },
    showClear: { type: Boolean, default: false },
    label: { type: String },
  },
});
